import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@arcadeai/design-system/components/ui/atoms/select";
import { Switch } from "@arcadeai/design-system/components/ui/atoms/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@arcadeai/design-system/components/ui/atoms/tooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { Info } from "lucide-react";
import { useFormContext } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

export const PkceFields = () => {
  const form = useFormContext<AuthProvider>();

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="oauth2.pkce.enabled"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Enable PKCE</FormLabel>
            </div>
            <FormControl>
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="oauth2.pkce.code_challenge_method"
        render={({ field }) => (
          <FormItem>
            <div className="flex w-full items-center justify-between gap-4">
              <FormLabel>Code Challenge Method</FormLabel>
              <TooltipProvider delay={200}>
                <Tooltip>
                  <TooltipTrigger
                    render={<span className="text-gray-500 text-sm" />}
                  >
                    <Info className="mr-1 size-4" />
                  </TooltipTrigger>
                  <TooltipContent>
                    Currently, S256 is the only supported code challenge method.
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <Select
              defaultValue={field.value}
              disabled
              onValueChange={field.onChange}
            >
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select method" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="S256">S256</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
